import { BaseQueryFn, createApi, FetchArgs, fetchBaseQuery, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react';
import { RootState } from '../store';
import { notification } from 'antd';

let baseUrl = process.env.REACT_APP_API_SERVER_URL;
let nucleusApiGatewayUrl = process.env.REACT_APP_NUCLEUS_API_GATEWAY_URL;
if (
    process.env.REACT_APP_INSTALLATION_MODE === 'desktop'
) {
    const port = process.env.REACT_APP_APPLICATION_NAME === 'Buildr' ? '3002' : '3001'
    baseUrl = `${window.location.protocol}//${window.location.hostname}:${port}`;
}

const baseQuery = fetchBaseQuery({
    baseUrl: baseUrl,
    prepareHeaders: (headers, { getState }) => {
        const token = (getState() as RootState).auth.token;
        if (token) {
            headers.set('Authorization', `Bearer ${token}`);
            headers.set('Content-Type', 'application/json');
            headers.set('source', 'activeteach');
        }
        return headers;
    },
});

const baseQueryWithReAuth: typeof baseQuery = async (
    args,
    api,
    extraOptions
) => {
    const result: any = await baseQuery(args, api, extraOptions);
    if (result.error) {
        const isLeadRoute =
            typeof args === 'string'
                ? args.includes('/api')
                : args.url.includes('/api');

        if (isLeadRoute) {
            const errorMessage =
                result.error.data?.name ||
                result.error.data?.msg ||
                'Something Went Wrong';

            notification.error({
                message: 'Error',
                description: errorMessage,
                duration: 3,
            });
        }
        if (
            (result.error.status === 500 &&
                result.error.data.name === 'JsonWebTokenError') ||
            result.error.status === 401
        ) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            if (
                !window.location.href.includes('login') &&
                process.env.REACT_APP_INSTALLATION_MODE !== 'desktop'
            ) {
                window.location.href = '/login';
            }
        }
    }
    return result;
};

const nucleusApiGatewayBaseQuery: BaseQueryFn<
    { acadId: string } & FetchArgs,
    unknown,
    FetchBaseQueryError,
    {},
    FetchBaseQueryMeta
> = async (args, api, extraOptions) => {
    const { acadId, ...rest } = args;
    const baseQuery = fetchBaseQuery({
        baseUrl: nucleusApiGatewayUrl,
        prepareHeaders: (headers, { getState }) => {
            const token = (getState() as RootState).auth.token;
            if (token) {
                headers.set('Authorization', `Bearer ${token}`);
                headers.set('Content-Type', 'application/json');
                headers.set('X-AcademicYearId', acadId);
                headers.set('academicyearid', acadId);
                headers.set('X-Product-Type', 'activeteach');
                headers.set('X-Product-Domain', window.location.hostname);
            }
            return headers;
        },
        // prepareHeaders: (headers, { getState }) => {
        //     const token = (getState() as RootState).auth.token;
        //     headers.set('Authorization', `Bearer ${token}`);
        //     headers.set('Content-Type', 'application/json');
        //     headers.set('source', 'activeteach');
        //     if(beURL === APIUrl.NUCLEUS_API_GATEWAY) {
        //         headers.set('X-AcademicYearId', "9");
        //         headers.set("X-Client-App", 'activeteach');
        //         headers.set('X-Product-Type', 'activeteach');
        //         headers.set('X-Product-Domain', window.location.hostname);
        //     }
        //     if (token) {
        //         headers.set('Authorization', `Bearer ${token}`);       
        //     }
        //     return headers;
        // },
    });
    const result: any = await baseQuery(rest, api, extraOptions);
    if (result.error) {
        const isLeadRoute =
            typeof args.url === 'string'
            && args.url.includes('/api');


        if (isLeadRoute) {
            const errorMessage =
                result.error.data?.name ||
                result.error.data?.msg ||
                'Something Went Wrong';

            notification.error({
                message: 'Error',
                description: errorMessage,
                duration: 3,
            });
        }
        if (
            (result.error.status === 500 &&
                result.error.data.name === 'JsonWebTokenError') ||
            result.error.status === 401
        ) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            if (
                !window.location.href.includes('login') &&
                process.env.REACT_APP_INSTALLATION_MODE !== 'desktop'
            ) {
                window.location.href = '/login';
            }
        }
    }
    return result;
};

export const apiClient = createApi({
    reducerPath: 'api',
    baseQuery: baseQueryWithReAuth,
    endpoints: () => ({}),
});

export const nucluesApiGatewayClient = createApi({
    reducerPath: "nucleusApiGateway",
    baseQuery: nucleusApiGatewayBaseQuery,
    endpoints: () => ({})
})